import { render, staticRenderFns } from "./EC03TF.vue?vue&type=template&id=1b4dcc18&"
import script from "./EC03TF.vue?vue&type=script&lang=js&"
export * from "./EC03TF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports